/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { List } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import ReservationSegmentEvent from '../../event/ReservationSegmentEvent'
import { ReservationSegmentState } from '../state/ReservationSegment'

class ReservationSegmentsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case ReservationSegmentEvent.fetch:
        const segments = payload.reservation_segments.map(s => ReservationSegmentState(s))
        return List(segments)

      case ReservationSegmentEvent.onEdit:
        const it = ReservationSegmentState({
          segment_category_id: payload.segment_category_id,
          segment_value_id: payload.segment_value_id
        })
        const found = state.count(obj => obj.segment_category_id === it.segment_category_id)
        return found ? state.map(x => (x.segment_category_id === it.segment_category_id ? it : x)) : state.push(it)

      default:
        return state
    }
  }
}

export default new ReservationSegmentsStore()
